"use client";
import React, { useEffect, useState } from "react";
import { useGlobalContext } from "@/contexts/AppContext";
import { useAuth } from "@/contexts/AuthContext";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { AppDispatch, AppState } from "@/store/configureStore";
import toast from "react-hot-toast";
import { yupResolver } from "@hookform/resolvers/yup";
import { CheckoutState, shippingOptions } from "@/utils/checkout";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useRouter } from "next/navigation";
import { updateOrder } from "@/store/slices/orderSlice";
import useOrders from "../account/useOrders";

const useCheckout = () => {
	const base_url = process.env.NEXT_PUBLIC_BASE_URL;
	const { theme, cartDetails } = useGlobalContext();
	const { token } = useSelector((state: AppState) => state.user);
	const { getOrder } = useOrders();
	const router = useRouter();
	const { delivery_fee, id } = useSelector((state: AppState) => state.order);
	const { isAuthenticated } = useAuth();
	const [paymentLoading, setPaymentLoading] = useState();
	const dispatch = useDispatch();

	const initiatePayment = async (data: CheckoutState) => {
		try {
			const adjustedData = {
				...data,
				name: data.isGift ? "" : data.name,
				phone: data.isGift ? "" : `+234${data.phone}`,
				receiversName: !data.isGift ? "" : data.receiversName,
				receiversPhone: !data.isGift ? "" : data.receiversPhone,
				sendersName: !data.isGift ? "" : data.sendersName,
				sendersPhone: !data.isGift ? "" : data.sendersPhone,
				deliveryFee: 3000,
				state: data.state === "Federal Capital Territory" ? "Abuja" : data.state,
			};

			const headers = token ? { Authorization: `Bearer ${token}` } : undefined;

			const response = await axios.post(
				`${base_url}/api/order/initiate`,
				adjustedData,
				headers ? { headers } : undefined
			);

			dispatch(updateOrder(response?.data?.data));
			return true;
		} catch (error: any) {
			toast.remove();
			toast.error(`An error occurred: ${error.response?.data?.error}`);
			return false;
		}
	};

	const registerOrder = async (
		status: string,
		totalCost: number,
		reference: string
	) => {
		try {
			const response = await axios.post(`${base_url}/api/order/payment`, {
				orderId: id,
				amount: totalCost,
				status: status,
				reference: reference,
				channel: "",
			});
			await getOrder(id);

			return true;
		} catch (error: any) {
			toast.remove();
			toast.error(`An error occurred: ${error.response?.data?.error}`);
			return false;
		}
	};

	return {
		theme,
		cartDetails,
		isAuthenticated,
		initiatePayment,
		registerOrder,
	};
};

export default useCheckout;
